import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react";
import { useDispatch, useSelector } from "react-redux";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import ModalComponent from "./ModalComponent";
import CONSTANTS from "../util/constants";
import { DataInput } from "./DataComponent";
import * as XLSX from "xlsx";
import Encrypt from "./../util/encrypt";
import { exportFile } from "../util/exportFile";

const TrailerManagementComp = () => {
  const gridRef = useRef();

  const [rowId, setRowId] = useState(0);
  const [modalShow, isModalShow] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [cellData, setCellClickData] = useState(null);
  const [isShowLog, isShowLogClicked] = useState(false);
  const rowDataRural = useSelector(
    (state) => state.ruralTrailer.getRuralTrailersData
  );
  const rowDataRuralLog = useSelector(
    (state) => state.ruralTrailer.getRuralTrailerLogsData
  );
  const userRoles = useSelector((state) => state.login.loginRolesData);
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );

  const dispatch = useDispatch();
  const [loginResponse, setLoginResponse] = useState(null);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    setCellClickData(null);

    dispatch({
      type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT
        .GET_TRAILER_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    setColumnDefs([
      {
        headerName: "Trailer No",
        field: "btId",
        filter: true,
        resizable: true,
        flex: 1,
        width: 100,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: "status",
        filter: true,
        resizable: true,
        flex: 1,
        width: 100,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: "designationLocation",
        filter: true,
        resizable: true,
        flex: 1,
        width: 100,
        minWidth: 200,
        maxWidth: 250,
        valueGetter: (params) => {
          const data = params.data;

          return data?.lotName !== null
            ? `${data?.lotName}_${data?.spaceNumber}`
            : data?.currentDoor !== null
            ? `${data?.doorType}_${data?.number}`
            : data?.currentLocationNew !== null
            ? data?.currentLocationNew
            : "Unknown";
        },
      },
      {
        headerName: "Date Entered",
        field: "purchaseDate",
        filter: true,
        resizable: true,
        flex: 1,
        width: 100,
        minWidth: 200,
        maxWidth: 250,
        valueGetter: (params) => {
          let dateTimeFormat;
          let myDate =
            params?.data?.purchaseDate != null &&
            params?.data?.purchaseDate != ""
              ? new Date(params?.data?.purchaseDate)
              : "";
          if (myDate != "" && myDate != null)
            dateTimeFormat =
              myDate?.getMonth() +
              1 +
              "/" +
              myDate?.getDate() +
              "/" +
              myDate?.getFullYear() +
              " " +
              formatAMPM(myDate);
          return dateTimeFormat;
        },
      },
      {
        field:
          loginResponse &&
          ((loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
            (loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.TRAILERADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
            (loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
              loginResponse?.user?.userRoles[0]?.priority))
            ? "Actions"
            : "",
        filter: true,
        resizable: true,
        flex: 1,
        cellRenderer: cellImageRender,
        width: 100,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: "Logs",
        filter: true,
        resizable: true,
        flex: 1,
        cellRenderer: cellLogStyle,
        cellClass:
          "border-radius-md bg-blue text-center me-4 d-flex align-items-center justify-content-center",
        width: 100,
        minWidth: 150,
        maxWidth: 200,
      },
    ]);
  }, [loginResponse]);

  useEffect(() => {
    let rowDataRuralActtiveStatus = rowDataRural;
    let filterData = rowDataRuralActtiveStatus?.filter((item) => {
      return divisionSelectedTemp?.value == item.division_id;
    });
    setRowData(filterData);
  }, [rowDataRural]);

  const cellImageRender = (params) => {
    return loginResponse &&
      ((loginResponse?.user?.userRoles[0]?.user_role_name ==
        CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
        loginResponse?.user?.userRoles[0]?.priority) ||
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.TRAILERADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
          loginResponse?.user?.userRoles[0]?.priority)) ? (
      <div
        onClick={() => {
          setCellClickData(params.data);
          showModal(true);
        }}
      >
        <img
          style={{ marginLeft: 20 }}
          src={require("./../assets/Dashboard/actions.png")}
        />
      </div>
    ) : null;
  };

  const cellLogStyle = (params) => {
    setCellClickData(params.data);

    return (
      <div
        onClick={() => {
          dispatch({
            type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
              .GET_RURAL_TRAILER_LOGS_API_CALL,
            payload: { value: params.data },
          });

          isShowLogClicked(true);
        }}
      >
        <p
          style={{
            width: "100%",
            height: "70%",
            backgroundColor: "rgb(0, 42, 74)",
            color: "white",
            borderRadius: 5,
            margin: 0,
            padding: "5px 10px",
            fontSize: 11,
          }}
        >
          {" "}
          <strong>{"Show Log"}</strong>{" "}
        </p>
      </div>
    );
  };

  const formatAMPM = (date) => {
    // This is to display 12 hour format like you asked
    var hours = date?.getHours();
    var minutes = date?.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    return strTime;
  };

  const [columnDefsLog] = useState([
    {
      headerName: "Date",
      field: "createdAt",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let myDate =
          params?.data?.createdAt != null && params?.data?.createdAt != ""
            ? new Date(params?.data?.createdAt)
            : "";
        let dateTimeFormat =
          myDate?.getMonth() +
          1 +
          "/" +
          myDate?.getDate() +
          "/" +
          myDate?.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },
    {
      headerName: "Type",
      field: "logType",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Volume Change",
      field: "volumeChange",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let volume =
          params?.data?.volumeChange != null &&
          params?.data?.volumeChange == true
            ? params?.data?.prevVolume + "->" + params?.data?.currentVolume
            : "";
        return volume;
      },
    },
    {
      headerName: "User",
      field: "driver",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let user =
          params?.data?.driver != null
            ? params?.data?.driver?.firstName +
              " " +
              params?.data?.driver?.lastName
            : "";
        return user;
      },
    },
    {
      headerName: "Relocation",
      field: "relocation",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let prevLocation =
          params?.data?.previousDoor != null
            ? params?.data?.previousDoor?.doorType +
              "_" +
              params?.data?.previousDoor?.number
            : params?.data?.previousSpace != null
            ? params?.data?.previousSpace?.lot?.lotName +
              "_" +
              params?.data?.previousSpace?.btId
            : params?.data?.prevLocation != null
            ? params?.data?.prevLocation
            : "UNKNOWN";

        let isArrow = prevLocation != "" ? "->" : "";

        let currentLocation =
          params?.data?.currDoor != null
            ? params?.data?.currDoor?.doorType +
              "_" +
              params?.data?.currDoor?.number
            : params?.data?.currSpace != null
            ? params?.data?.currSpace?.lot?.lotName +
              "_" +
              params?.data?.currSpace?.btId
            : params?.data?.currentLocation != null
            ? params?.data?.currentLocation
            : "UNKNOWN";

        let volume = prevLocation + isArrow + currentLocation;
        return volume;
      },
    },
  ]);

  const [columnDefs, setColumnDefs] = useState([]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
  }));

  const cellClickedListener = useCallback((event) => {}, []);

  const showModal = (isShow) => {
    isModalShow(isShow);
  };

  const paginationNumberFormatter = useCallback((params) => {
    return "[" + params.value.toLocaleString() + "]";
  }, []);

  const onGridReady = useCallback((params) => {
    dispatch({
      type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
        .GET_RURAL_TRAILER_MANAGEMENT_API_CALL,
    });
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage(1);
  }, []);

  const importTrailer = (file) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */

      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 0 });
      /* Update state */
      if (data && data.length > 0) {
        let payload = [];
        for (let i = 0; i < data.length; i++) {
          payload.push({
            btId: data[i].btId,
            destinationLocation: data[i].destinationLocation,
            condition: data[i].condition,
            purchaseDate: data[i].purchaseDate,
            status: data[i].status,
          });
        }
        dispatch({
          type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.TRAILER_BULK_API_CALL,
          payload: { value: payload },
        });
      } else {
        alert("Failed to load data");
      }
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  return (
    <div className="row">
      {modalShow ? (
        <ModalComponent
          title={cellData != null ? "Edit Trailer" : "Add trailer"}
          show={showModal}
          handleClose={showModal}
          rowId={rowId}
          isShow={showModal}
          rowData={cellData}
          setValue={(value) => {
            isModalShow(false);

            if (cellData != null) {
              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT
                  .EDIT_TRAILER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            } else {
              dispatch({
                type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT
                  .ADD_TRAILER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      {isShowLog ? (
        <div
          className="col-md-12 col-sm-12 ag-theme-alpine"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "80vh",
            width: "80vw",
            justifyContent: "space-between",
          }}
        >
          <div
            onClick={() => {
              isShowLogClicked(false);
            }}
            className="row wrapper col-8 col-md-4 col-sm-6 col-lg-3"
            style={{
              marginLeft: 12,
              marginBottom: 5,
              height: "4vh",
              width: "auto",
              backgroundColor: "darkGray",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <label
              style={{ fontSize: "1.1em", color: "white", textAlign: "center" }}
            >
              {"Show All Trailers"}
            </label>
          </div>

          <div
            className="col-12 col-lg-12 col-md-12 col-sm-12 "
            style={{
              height: "40vh",
            }}
          >
            <div
              className="col-12 collg-12 col-md-12 col-sm-12 "
              style={{
                display: "flex",
                height: "6vh",
                backgroundColor: "#0dcaf0",
                border: "2px solid rgba(0, 0, 0, 0.1)",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label style={{ fontSize: 18, color: "white" }}>
                {"Rural Hall Trailer :"}
                {cellData?.btId}
              </label>
            </div>

            <div
              className="col-12 col-lg-12 col-md-12 col-sm-12 "
              style={{
                display: "flex",
                flexDirection: "column",
                height: "30vh",
                backgroundColor: "white",
                border: "2px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              <div
                className="row col-12 col-lg-12 col-md-12 col-sm-12 "
                style={{
                  display: "flex",
                  height: "10vh",
                  backgroundColor: "white",
                  borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Trailer : \n"}
                    {cellData?.btId}
                  </label>
                </div>
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Current Location : \n"}
                    {rowDataRuralLog && rowDataRuralLog?.length > 0
                      ? rowDataRuralLog[0]?.currentDoor != null
                        ? (rowDataRuralLog[0]?.currDoor?.doorType || "") +
                          "_" +
                          (rowDataRuralLog[0]?.currDoor?.number || "")
                        : rowDataRuralLog[0]?.currentSpace != null
                        ? (rowDataRuralLog[0]?.currSpace?.lot?.lotName || "") +
                          "_" +
                          (rowDataRuralLog[0]?.currSpace?.btId || "")
                        : rowDataRuralLog[0]?.currentLocation != null
                        ? rowDataRuralLog[0]?.currentLocation
                        : "Unknown"
                      : "Unknown"}
                    {/* {rowDataRuralLog[0]?.lotName !== null
                      ? `${rowDataRuralLog[0]?.lotName}_${rowDataRuralLog[0]?.spaceNumber}`
                      : rowDataRuralLog[0]?.currentDoor !== null
                      ? `${rowDataRuralLog[0]?.doorType}_${rowDataRuralLog[0]?.number}`
                      : rowDataRuralLog[0]?.currentLocationNew !== null
                      ? rowDataRuralLog[0]?.currentLocationNew
                      : "Unknown"} */}
                  </label>
                </div>
              </div>

              <div
                className="row col-12 col-lg-12 col-md-12 col-sm-12"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "10vh",
                  backgroundColor: "white",
                  borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Current Trailer Capacity : \n"}
                    {cellData?.currentLoad}
                  </label>
                </div>

                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Seal Number : \n"}
                    {cellData?.sealNum}
                  </label>
                </div>
              </div>

              <div
                className="row col-12 col-lg-12 col-md-12 col-sm-12 "
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "10vh",
                  backgroundColor: "white",
                  borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Product Number : \n"}
                    {cellData?.productNum}
                  </label>
                </div>

                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Actual Count : \n"}
                    {cellData?.actualCount}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-md-12 col-sm-12 ag-theme-alpine"
            style={{
              height: "40vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <AgGridReact
              ref={gridRef}
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              onCellClicked={cellClickedListener}
              rowData={rowDataRuralLog}
              pagination={false}
              paginationAutoPageSize={false}
              paginationPageSize={10}
              paginateChildRows={false}
              enableRangeSelection={false}
              suppressRowClickSelection={false}
              groupSelectsChildren={false}
              rowSelection={"multiple"}
              rowGroupPanelShow={"always"}
              pivotPanelShow={"always"}
              columnDefs={columnDefsLog}
              onGridReady={onGridReady}
              onFirstDataRendered={onFirstDataRendered}
            ></AgGridReact>
          </div>
        </div>
      ) : (
        <div className="col-md-12 col-sm-12 col-12">
          <div
            onClick={() => {
              setCellClickData(null);
            }}
            className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              margin: "2px 0 2px 0px",
            }}
          >
            {loginResponse &&
            ((loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.TRAILERADMIN &&
                loginResponse?.user?.userRoles[0]?.priority)) ? (
              <DataInput handleFile={importTrailer} />
            ) : null}
            <div className="ms-md-auto pe-md-3 d-flex align-items-center">
              <div className="input-group">
                <span className="input-group-text text-body">
                  <i className="fas fa-search" aria-hidden="false"></i>
                </span>
                <input
                  aria-label="Search"
                  autoComplete={"false"}
                  data-html={true}
                  data-tip="&amp;#8226; Use atleast 12 characters.<br />
                                    &amp;#8226; Include both lowercase and uppercase characters.<br />
                                    &amp;#8226; Include atleast one number or symbol.<br />
                                    &amp;#8226; Password should not be based on any personal information such as user id, family name, pet, birthday, friends, co-workers, addresses, phone numbers, etc."
                  aria-describedby="basic-addon2"
                  type="text"
                  className="form-control"
                  placeholder="Type here..."
                  onChange={(value) => {
                    let filterData = [];
                    if (value.target?.value == "") {
                      filterData = rowDataRural;
                      setRowData(filterData);
                    } else {
                      filterData = rowDataRural?.filter((item) => {
                        return (
                          item.btId
                            ?.toLowerCase()
                            ?.includes(value.target.value.toLowerCase()) ||
                          item.currentLocation
                            ?.toLowerCase()
                            ?.includes(value.target.value.toLowerCase()) ||
                          item.currentLoad
                            ?.toLowerCase()
                            ?.includes(value.target.value.toLowerCase()) ||
                          item.trailer?.btId?.includes(value.target.value) ||
                          item.condition
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.designationLocation
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.status
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase())
                        );
                      });
                      setRowData(filterData);
                    }
                  }}
                ></input>
              </div>
            </div>
            {isShowLog ||
            (loginResponse &&
              ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
                (loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                  loginResponse?.user?.userRoles[0]?.priority))) ? (
              <p
                style={{
                  fontSize: 14,
                  textAlign: "center",
                  backgroundColor: "lightBlue",
                  borderRadius: 8,
                  marginLeft: 14,
                  padding: 6,
                  margin: 0,
                }}
                onClick={() => {
                  let exportData = [];

                  for (let i = 0; i < rowData?.length; i++) {
                    let dateTimeFormat;
                    let myDate =
                      rowData[i].purchaseDate != null &&
                      rowData[i]?.purchaseDate != ""
                        ? new Date(rowData[i]?.purchaseDate)
                        : "";
                    if (myDate != "" && myDate != null)
                      dateTimeFormat =
                        myDate?.getMonth() +
                        1 +
                        "/" +
                        myDate?.getDate() +
                        "/" +
                        myDate?.getFullYear() +
                        " " +
                        formatAMPM(myDate);
                    let data = {
                      "Trailer No": rowData[i]?.btId,
                      Status: rowData[i].status,
                      "Designation Location": rowData[i]?.designationLocation,
                      "Date Entered": dateTimeFormat,
                    };
                    exportData[i] = data;
                  }

                  exportFile("TrailerReport", exportData, [
                    "Trailer No",
                    "Status",
                    "Designation Location",
                    "Date Entered",
                  ]);
                }}
              >
                EXPORT
              </p>
            ) : null}
            {loginResponse &&
            ((loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                loginResponse?.user?.userRoles[0]?.priority)) ? (
              <img
                onClick={() => {
                  setCellClickData(null);
                  isModalShow(true);
                }}
                src={require("./../assets/Dashboard/plus.png")}
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              ></img>
            ) : null}
          </div>

          <div
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine"
            style={{
              height: "80vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <AgGridReact
              ref={gridRef}
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              onCellClicked={cellClickedListener}
              rowData={rowData}
              pagination={false}
              paginationAutoPageSize={true}
              paginationPageSize={10}
              paginateChildRows={true}
              enableRangeSelection={true}
              suppressRowClickSelection={true}
              groupSelectsChildren={true}
              rowSelection={"multiple"}
              rowGroupPanelShow={"always"}
              pivotPanelShow={"always"}
              columnDefs={columnDefs}
              paginationNumberFormatter={paginationNumberFormatter}
              onGridReady={onGridReady}
              onFirstDataRendered={onFirstDataRendered}
            ></AgGridReact>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrailerManagementComp;
